import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/',
    // redirect: '/shopList',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    children: [
      {
        path: '/',
        name: 'ShopList',
        component: () => import('../views/shopList.vue')
      },
      {
        path: '/reservation',
        name: 'Reservation',
        component: () => import('../views/reservation.vue')
      },
      {
        path: '/shoppingCart',
        name: 'ShoppingCart',
        component: () => import('../views/shoppingCart.vue')
      },
      {
        path: '/userInfo',
        name: 'UserInfo',
        component: () => import('../views/user/info.vue')
      },
      {
        path: '/orderRecord',
        name: 'OrderRecord',
        component: () => import('../views/orderRecord.vue')
      },
      {
        path: '/orderDetail',
        name: 'OrderDetail',
        component: () => import('../views/orderDetail.vue')
      },
    ]
  },
  {
    path: '/abort',
    name: 'Abort',
    component: () => import('../views/abort.vue')
  },
  {
    path: '/terms-of-use',
    name: 'terms_of_use',
    component: () => import('../views/terms_of_use.vue')
  },
  {
    path: '/frequently-asked-questions',
    name: 'frequently_asked_questions',
    component: () => import('../views/frequently_asked_questions.vue')
  },
  {
    path: '/precautions',
    name: 'precautions',
    component: () => import('../views/precautions.vue')
  },
  {
    path: '/privacy-policy',
    name: 'privacy_policy',
    component: () => import('../views/privacy_policy.vue')
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
